var _rect, _rect2, _rect3, _rect4, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBinary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_7015_2496)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 18,
    height: 18,
    rx: 9,
    fill: "url(#paint0_linear_7015_2496)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 18,
    height: 18,
    rx: 9,
    fill: "url(#paint1_linear_7015_2496)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.02941,
    y: 0.529412,
    width: 16.9412,
    height: 16.9412,
    rx: 8.47059,
    stroke: "url(#paint2_linear_7015_2496)",
    strokeWidth: 1.05882
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.02941,
    y: 0.529412,
    width: 16.9412,
    height: 16.9412,
    rx: 8.47059,
    stroke: "#17D560",
    strokeOpacity: 0.5,
    strokeWidth: 1.05882
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.02941,
    y: 0.529412,
    width: 16.9412,
    height: 16.9412,
    rx: 8.47059,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.05882,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7015_2496)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.821 9.61712L9.9321 13.506C9.69346 13.7447 9.30654 13.7447 9.0679 13.506L5.17898 9.61712C4.94034 9.37848 4.94034 8.99156 5.17898 8.75292C5.41763 8.51428 5.80454 8.51428 6.04319 8.75292L8.88892 11.5986L8.88892 4.92615C8.88892 4.58866 9.16251 4.31506 9.5 4.31506C9.83749 4.31506 10.1111 4.58866 10.1111 4.92615L10.1111 11.5986L12.9568 8.75292C13.1955 8.51428 13.5824 8.51428 13.821 8.75292C14.0597 8.99156 14.0597 9.37848 13.821 9.61712Z",
    fill: "url(#paint3_linear_7015_2496)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.821 9.61712L9.9321 13.506C9.69346 13.7447 9.30654 13.7447 9.0679 13.506L5.17898 9.61712C4.94034 9.37848 4.94034 8.99156 5.17898 8.75292C5.41763 8.51428 5.80454 8.51428 6.04319 8.75292L8.88892 11.5986L8.88892 4.92615C8.88892 4.58866 9.16251 4.31506 9.5 4.31506C9.83749 4.31506 10.1111 4.58866 10.1111 4.92615L10.1111 11.5986L12.9568 8.75292C13.1955 8.51428 13.5824 8.51428 13.821 8.75292C14.0597 8.99156 14.0597 9.37848 13.821 9.61712Z",
    fill: "#17D560",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.821 9.61712L9.9321 13.506C9.69346 13.7447 9.30654 13.7447 9.0679 13.506L5.17898 9.61712C4.94034 9.37848 4.94034 8.99156 5.17898 8.75292C5.41763 8.51428 5.80454 8.51428 6.04319 8.75292L8.88892 11.5986L8.88892 4.92615C8.88892 4.58866 9.16251 4.31506 9.5 4.31506C9.83749 4.31506 10.1111 4.58866 10.1111 4.92615L10.1111 11.5986L12.9568 8.75292C13.1955 8.51428 13.5824 8.51428 13.821 8.75292C14.0597 8.99156 14.0597 9.37848 13.821 9.61712Z",
    fill: "white",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_7015_2496",
    x: -1.81016,
    y: -2.31016,
    width: 22.6203,
    height: 22.6203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.15508
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_7015_2496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_7015_2496",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7015_2496",
    x: 1.82353,
    y: 1.13859,
    width: 15.3529,
    height: 15.7229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.58824
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.166667 0 0 0 0 1 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7015_2496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7015_2496",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7015_2496",
    x1: 6.79759,
    y1: 9.46709e-7,
    x2: 19.543,
    y2: 0.77161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#152031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7015_2496",
    x1: 9.5,
    y1: -9.43548,
    x2: 9.50001,
    y2: 21.9194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383839",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242424"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7015_2496",
    x1: 6.79759,
    y1: 9.46709e-7,
    x2: 19.543,
    y2: 0.77161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20AA29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#109868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7015_2496",
    x1: 14,
    y1: 7.59329,
    x2: 13.582,
    y2: 14.2259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20AA29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#109868"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBinary);
export default __webpack_public_path__ + "static/media/arrowBinary.d7a8ebc2a43e9d733c17af180da225fa.svg";
export { ForwardRef as ReactComponent };